<div class="results">

  <table *ngIf="!links">
    <tbody>
      <tr class="loading">
        <td class="text-center" colspan="2">
          Chargement...
        </td>
      </tr>
    </tbody>
  </table>

  <table *ngIf="links">
    <thead>
      <tr>
        <th>Appartenant à</th>
        <th style="width: 64px;"></th>
      </tr>
    </thead>

    <tbody *ngIf="links.belongs_to.length > 0">
      <tr *ngFor="let link of links.belongs_to" (click)="link.selected = !link.selected">
        <td>{{ link.entity.name }}</td>
        <td class="actions" style="width: 64px">
          <a class="action-btn" *ngIf="link.selected">
            <t-icon name="check"></t-icon>
          </a>
        </td>
      </tr>
    </tbody>

    <tbody *ngIf="links.belongs_to.length == 0">
      <tr>
        <td class="text-center" colspan="2">
          <ng-container *ngIf="links.belongs_to.length == 0">
            Aucun lien n'a été trouvé
          </ng-container>
        </td>
      </tr>
    </tbody>

  </table>

  <table *ngIf="links">
      <thead>
        <tr>
          <th>A des titres dans</th>
          <th style="width: 64px;"></th>
        </tr>
      </thead>
  
      <tbody *ngIf="links.has_shares_in.length > 0">
        <tr *ngFor="let link of links.has_shares_in" (click)="link.selected = !link.selected">
          <td>{{ link.entity.name }}</td>
          <td class="actions" style="width: 64px">
            <a class="action-btn" *ngIf="link.selected">
              <t-icon name="check"></t-icon>
            </a>
          </td>
        </tr>
      </tbody>
  
      <tbody *ngIf="links.has_shares_in.length == 0">
        <tr>
          <td class="text-center" colspan="2">
            <ng-container *ngIf="links.has_shares_in.length == 0">
              Aucun lien n'a été trouvé
            </ng-container>
          </td>
        </tr>
      </tbody>
  
    </table>

</div>

<div class="buttons">
  <button class="btn btn-small btn-primary" [disabled]="!hasSelected" (click)="add()">
    <t-icon name="check"></t-icon>
    <span class="text">Ajouter</span>
  </button>

  <a class="btn btn-small btn-gray" (click)="cancel()">
    <t-icon name="close"></t-icon>
    <span class="text">Annuler</span>
  </a>
</div>